/**
 * 时间格式过滤器
 * @param val
 * @returns {string}
 */
const formatTime = function (val) {
  if (!val) return '--'
  if (val === -1) return '--'
  const now = new Date(val)
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const date = now.getDate() > 9 ? now.getDate() : `0${now.getDate()}`
  const hours = now.getHours() > 9 ? now.getHours() : `0${now.getHours()}`
  const minutes = now.getMinutes() > 9 ? now.getMinutes() : `0${now.getMinutes()}`
  const seconds = now.getSeconds() > 9 ? now.getSeconds() : `0${now.getSeconds()}`
  return `${year}-${month}-${date}, ${hours}:${minutes}:${seconds}`
}
/**
 * 项目地址过滤器
 * @param val
 * @returns {*}
 */
const toLocationStr = function (val) {
  try {
    let json = JSON.parse(val)
    return json.province + json.city + json.area
  } catch (e) {
    return val
  }
}
/**
 * 项目产品类型过滤器
 * @param val
 * @returns {*}
 */
const productType = function (val) {
  let type = ''
  switch (parseInt(val)) {
    case -1 :
      type = '其他'
      break
    case 0 :
      type = '恒流控制器'
      break
    case 1 :
      type = '人体感应'
      break
    case 2 :
      type = '市电互补'
      break
    case 3 :
      type = '开关控制器'
      break
  }
  return type
}
/**
 * 设备电压、电流过滤器
 * @param value
 * @returns {string}
 */
const electricValToFixed = function (value) {
  return (value / 1000).toFixed(2)
}
/**
 * 设备信号强度图标显示过滤器
 * */
const getSignalImg = function (value) {
  const { signalIntensity } = value
  let signal = 0
  switch (signalIntensity) {
    case 1:
      signal = 5
      break
    case 2:
      signal = 4
      break
    case 3:
      signal = 3
      break
    case 4:
      signal = 2
      break
    case 5:
      signal = 1
      break
    default:
      signal = 0
      break
  }
  return require(`../../images/signal-${signal}.png`)
}
const Filters = {
  formatTime,
  toLocationStr,
  productType,
  electricValToFixed,
  getSignalImg
}
export default Filters
